import React, { memo, useCallback } from "react"
import LinkButtonMore from "../../../components/buttons/linkButtonMore/linkButtonMore"
import Mark from "../../../components/svg/new/Mark"
import { appNavigate } from "../../../utils/functions"
import * as style from "./sectionTitle.module.css"
import parse from "html-react-parser"

const SectionTitle = ({
  title,
  btnName,
  SubTitle,
  Btnclass,
  href,
  Content,
  styleCss,
  classnames = "",
  type,
  animation,
}) => {
  const handleNavigation = useCallback(
    e => {
      e.preventDefault()
      appNavigate(href)
    },
    [href]
  )

  const renderTitle = title && (
    <div className={style.viewAllLink}>
      <span className={animation === "yes" ? "" : style.small_text_span}>
        <i>
          <Mark />
        </i>
        {title}
      </span>
      <a href={href} onClick={handleNavigation} style={styleCss}>
        <LinkButtonMore Btnclass={Btnclass} btnText={btnName} />
      </a>
    </div>
  )

  return (
    <div className={`${classnames} ${style.mix_heading_wrap}`}>
      <div className={style.mix_heading}>
        {type === "horizontal" ? (
          <div className={style.mix_heading_Root}>
            {renderTitle}
            {SubTitle && <h2>{SubTitle}</h2>}
            {Content && <p>{parse(`${Content}`)}</p>}
          </div>
        ) : (
          <>
            {renderTitle}
            {SubTitle && <h2>{SubTitle}</h2>}
            {Content && <p>{animation === "yes" ? Content : parse(`${Content}`)}</p>}
          </>
        )}
      </div>
    </div>
  )
}

export default memo(SectionTitle)
